/** Último filtro de la lista de empresas (?q=…) en esta pestaña, para volver a la lista sin perderlo. */
export const CLAVE_FILTROS_EMPRESAS = 'admin.empresas.filtros';

/** Ruta de la lista de empresas con el último filtro usado en esta pestaña. */
export function rutaListaEmpresas(): string {
  try {
    return `/empresas${sessionStorage.getItem(CLAVE_FILTROS_EMPRESAS) ?? ''}`;
  } catch {
    return '/empresas';
  }
}
